import { Skeleton } from '@mui/material';

export const ReviewsSkeleton = () => {
    return [...Array(10)].map((_, index) => (
        <div key={index} className='rounded-lg border border-solid border-gray-100 bg-gray-50 p-2'>
            <div className='px-1'>
                <div className='flex items-center justify-between'>
                    <Skeleton variant='text' width={120} height={24} />
                    <Skeleton variant='text' width={60} height={18} />
                </div>

                <Skeleton variant='text' width={100} height={20} className='mt-1' />
            </div>

            <div className='mt-2 rounded-lg border border-solid border-gray-100 bg-white p-2'>
                <div className='flex items-center gap-1'>
                    <Skeleton variant='circular' width={12} height={12} />
                    <Skeleton variant='text' width={120} height={16} />
                </div>

                <Skeleton variant='rectangular' height={1} className='my-4 opacity-10' />

                <Skeleton variant='text' width='70%' height={18} />
            </div>

            <div className='mt-1 rounded-lg border border-solid border-gray-100 bg-white p-2'>
                <Skeleton variant='text' width='100%' height={16} />
                <Skeleton variant='text' width='95%' height={16} />
                <Skeleton variant='text' width='80%' height={16} />
            </div>
        </div>
    ));
};
